import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray300, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio } from '@yme/utils/constants';
export const DropDownListHolderStyled = styled.div `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 8px;
  position: ${({ useForMobile }) => (useForMobile ? 'static' : 'absolute')};
  top: 100%;

  border: ${({ useForMobile }) => (useForMobile ? 'none' : `1px solid ${colorCoreGray300}`)};
  background-color: ${colorCoreWhite1000};
  z-index: ${Z_INDEX.level1};

  border-radius: ${({ useForMobile }) => (useForMobile ? 'none' : CORNER_RADIUS.m)};
  display: ${({ isExpandedDropDown }) => (isExpandedDropDown ? 'flex' : 'none')};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const DropDownListHolderDefaultStyled = styled.div `
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0;
  margin-top: 8px;
  position: ${({ useForMobile }) => (useForMobile ? 'static' : 'absolute')};
  top: 100%;

  border: ${({ useForMobile }) => (useForMobile ? 'none' : `1px solid ${colorCoreGray300}`)};
  background-color: ${colorCoreWhite1000};
  z-index: ${Z_INDEX.level1};

  border-radius: ${({ useForMobile }) => (useForMobile ? 'none' : CORNER_RADIUS.m)};
  display: ${({ isExpandedDropDown }) => (isExpandedDropDown ? 'flex' : 'none')};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const DropDownListStyled = styled.ul `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  width: 100%;
  list-style: none;

  ${({ useForMobile }) => !useForMobile &&
    css `
      box-shadow: ${elevationBottomLvl2};
      border-radius: ${CORNER_RADIUS.m};
    `}

  ${({ withScroll, useForMobile }) => {
    if (withScroll) {
        return CustomScroll;
    }
    if (!withScroll && useForMobile) {
        return 'padding: 0;';
    }
    return 'padding: 6px;';
}}

  ${({ maxHeightValue }) => maxHeightValue && `max-height: ${maxHeightValue};`}

  ${({ useForMobile }) => useForMobile && 'border: none;'}
`;
export const ItemOptionStyled = styled.li `
  display: flex;
  flex-direction: row;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  padding: ${({ useForMobile }) => (useForMobile ? '8px 12px' : '10px 12px')};
  width: 100%;
  cursor: pointer;
  text-transform: capitalize;

  border-radius: ${CORNER_RADIUS.xs};
  color: ${colorCoreBlack900Base};

  background-color: ${({ isActiveEntity }) => isActiveEntity ? colorBlackTransparent50 : defaultTransparent};

  background-color: ${({ isHovered }) => isHovered ? colorBlackTransparent50 : defaultTransparent};

  &:hover {
    background-color: ${colorCoreGray300};
  }
`;
export const RegularTextLevel4Styled = styled(RegularTextLevel4) `
  margin: 0 4px 0 0;
`;
export const ImageContainerStyled = styled.div `
  margin-right: 12px;
  aspect-ratio: ${AspectRatio.RectangleLevel3};
  width: 86px;
  height: 48px;

  ${ADAPTIVE.maxWidth.tablet} {
    width: 64px;
    height: 37px;
  }
`;
